import { arrayBufferDownload, arrayBufferDownloadExcel, downloadCSV } from "../../../../utils/download";
import { decorateEmptyGridValues, setColumnDefaultExtraProps } from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_RATEADMIN_EXTRAPRODUCTCATEGORY_LIST,
  TOAST,
  FETCH_RATEADMIN_EXTRAPRODUCTCATEGORY_INIT,
  FETCH_RATEADMIN_EXTRAPRODUCTCATEGORY_DETAIL,
  EXPORT_RATEADMIN_EXTRAPRODUCTCATEGORY,
  CREATE_RATEADMIN_EXTRAPRODUCTCATEGORY,
  EDIT_RATEADMIN_EXTRAPRODUCTCATEGORY,
  INIT_CREATE_RATEADMIN_EXTRAPRODUCTCATEGORY_SCREEN,
  RATEADMIN_EXTRAPRODUCTCATEGORYDD,
  DELETE_RATEADMIN_EXTRAPRODUCTCATEGORY,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  RATEADMIN_EXTRAPRODUCTCATEGORY_SAVE_TABLE_STATE
} from "../../../types/rateadminextraproductcategory.type";



const formFieldValueMap = {
  id: null,
  description: "",
  modBy: "",
  modTime: "",
  status: 1,
  title: "",
  userId: ""
};

const INITIAL_STATE = {
  rateAdminExtraProductCategoryListview: [],
  ExtraProductCategoryDD: [],
  isRateAdminExtraProductCategoryDDSuccess: false,
  isRateAdminExtraProductCategoryDDError: false,
  isLoading: false,
  error: null,
  formFieldValueMap,
  isRateAdminExtraProductCategoryCreateSuccess: false,
  isRateAdminExtraProductCategoryCreateError: false,
  isRateAdminExtraProductCategoryDetailSuccess: false,
  isRateAdminExtraProductCategoryDetailError: false,
  isRateAdminExtraProductCategoryEditSuccess: false,
  isRateAdminExtraProductCategoryEditError: false,
  isRateAdminExtraProductCategoryExportSuccess: false,
  isRateAdminExtraProductCategoryExportError: false,
  isUploadImageSuccess: false,
  isUploadImageError: false,
  imageUploadResponse: null,
  savedTableState: null
};

const tranformToGridView = (data) => {
  const rows = data.map((item) => {
    const {
      crtBy,
      crtTime,
      description,
      id,
      modBy,
      modTime,
      status,
      title
    } = item;

    const transformedValues = {
      crtBy,
      crtTime,
      description,
      id,
      modBy,
      modTime,
      status,
      title
    };
    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "ID",
      dataKey: "id",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Extra Category",
      dataKey: "title",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Description",
      dataKey: "description",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },


    {
      colLabel: "Crt By",
      dataKey: "crtBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Crt Time",
      dataKey: "crtTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Mod By",
      dataKey: "modBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Edit Time",
      dataKey: "modTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    }
  ];

  return {
    datas: { columns, rows },
  };
};

export const rateadminExtraProductCategoryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RATEADMIN_EXTRAPRODUCTCATEGORY_INIT:
      return { ...INITIAL_STATE, savedTableState: state.savedTableState, isLoadingPage: true };
    case FETCH_RATEADMIN_EXTRAPRODUCTCATEGORY_DETAIL.START:
    case EXPORT_RATEADMIN_EXTRAPRODUCTCATEGORY.START:
    case UPLOAD_IMAGE.START:
    case FETCH_RATEADMIN_EXTRAPRODUCTCATEGORY_LIST.START:
    case CREATE_RATEADMIN_EXTRAPRODUCTCATEGORY.START:
    case EDIT_RATEADMIN_EXTRAPRODUCTCATEGORY.START:
    case RATEADMIN_EXTRAPRODUCTCATEGORYDD.START:
    case DELETE_RATEADMIN_EXTRAPRODUCTCATEGORY.START:
      return { ...state, isLoading: true };

    case FETCH_RATEADMIN_EXTRAPRODUCTCATEGORY_LIST.SUCCESS: {
      const { page, data } = action.payload;

      let resetState = {
        rateAdminExtraProductCategoryListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isRateAdminExtraProductCategoryCreateSuccess: false,
        isRateAdminExtraProductCategoryCreateError: false,
        savedTableState: state.savedTableState,
      };
      if (!data) {
        return resetState;
      }
      const { number, size, totalElements, totalPages } = page;
      const { datas } = tranformToGridView(data);
      return {
        ...resetState,
        rateAdminExtraProductCategoryListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }
    case FETCH_RATEADMIN_EXTRAPRODUCTCATEGORY_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        rateAdminExtraProductCategoryListview: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        israteadminExtraProductCategoryDeletionSuccess: false,
        israteadminExtraProductCategoryDeletionError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case FETCH_RATEADMIN_EXTRAPRODUCTCATEGORY_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isRateAdminExtraProductCategoryDetailSuccess: true,
      };
    }
    case FETCH_RATEADMIN_EXTRAPRODUCTCATEGORY_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminExtraProductCategoryDetailSuccess: false,
        isRateAdminExtraProductCategoryDetailError: true,
      };
    }

    //DD
    case RATEADMIN_EXTRAPRODUCTCATEGORYDD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        ExtraProductCategoryDD: temp,
        isRateAdminExtraProductCategoryDDSuccess: true,
        isRateAdminExtraProductCategoryDDError: false,
      };
    }
    case RATEADMIN_EXTRAPRODUCTCATEGORYDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminExtraProductCategoryDDSuccess: false,
        isRateAdminExtraProductCategoryDDError: true,
      };
    }
    //END DD


    // UPLOAD_IMAGE Start
    case UPLOAD_IMAGE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isUploadImageSuccess: false,
        isUploadImageError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case UPLOAD_IMAGE.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        imageUploadResponse: data,
        isUploadImageSuccess: true,
        isUploadImageError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // UPLOAD_IMAGE End

    // Export Start
    case EXPORT_RATEADMIN_EXTRAPRODUCTCATEGORY.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isRateAdminExtraProductCategoryExportSuccess: false,
        isRateAdminExtraProductCategoryExportError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EXPORT_RATEADMIN_EXTRAPRODUCTCATEGORY.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "extra-product-category.xls");
      return {
        ...state,
        isRateAdminExtraProductCategoryExportSuccess: true,
        isRateAdminExtraProductCategoryExportError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // Export End

    // EDIT
    case EDIT_RATEADMIN_EXTRAPRODUCTCATEGORY.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminExtraProductCategoryEditSuccess: false,
        isRateAdminExtraProductCategoryEditError: true,
      };
    }

    case EDIT_RATEADMIN_EXTRAPRODUCTCATEGORY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isRateAdminExtraProductCategoryEditSuccess: true,
        isRateAdminExtraProductCategoryEditError: false,
      };
    }

    // EDIT END

    // Create
    case INIT_CREATE_RATEADMIN_EXTRAPRODUCTCATEGORY_SCREEN: {
      return { ...INITIAL_STATE, savedTableState: state.savedTableState };
    }

    case CREATE_RATEADMIN_EXTRAPRODUCTCATEGORY.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminExtraProductCategoryCreateSuccess: false,
        isRateAdminExtraProductCategoryCreateError: true,
      };
    }
    case CREATE_RATEADMIN_EXTRAPRODUCTCATEGORY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isRateAdminExtraProductCategoryCreateSuccess: true,
        isRateAdminExtraProductCategoryCreateError: false,
      };
    }

    //End


    case TOAST.RESET: {
      return {
        ...state,
        isRateAdminExtraProductCategoryCreateSuccess: false,
        isRateAdminExtraProductCategoryCreateError: false,
        isRateAdminExtraProductCategoryEditError: false,
        isRateAdminExtraProductCategoryEditSuccess: false,
        isRateAdminExtraProductCategoryDetailError: false
      };
    }

    case DELETE_RATEADMIN_EXTRAPRODUCTCATEGORY.SUCCESS:
      return { 
        ...state, 
        isLoading: false, 
        isRateAdminExtraProductCategoryDeleteSuccess: true, 
        isRateAdminExtraProductCategoryDeleteError: false, 
        shouldOpenDeleteConfirmationPopup: false 
      };
    case DELETE_RATEADMIN_EXTRAPRODUCTCATEGORY.ERROR: {
      const { error } = action.payload;
      return { 
        ...state, 
        error, 
        isLoading: false, 
        isRateAdminExtraProductCategoryDeleteSuccess: false, 
        isRateAdminExtraProductCategoryDeleteError: true, 
        shouldOpenDeleteConfirmationPopup: false 
      };
    }
    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY:
      return { 
        ...state, 
        shouldOpenDeleteConfirmationPopup: action.payload, 
        isRateAdminExtraProductCategoryDeleteSuccess: false, 
        isRateAdminExtraProductCategoryDeleteError: false 
      };

    case RATEADMIN_EXTRAPRODUCTCATEGORY_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }
    default:
      return state;
  }
};
